{
  "version": 1,
  "asset_id": "21c03975-cbb2-475d-9793-9e8cdb505225",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/21c03975-cbb2-475d-9793-9e8cdb505225/hiatal-type-2-v3-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/21c03975-cbb2-475d-9793-9e8cdb505225/hiatal-type-2-v3-800.webp",
  "original_filename": "hiatal-type-2-v3-800.webp",
  "size": 76642,
  "content_type": "image/webp",
  "created_at": "2026-10-28T19:42:18Z"
}
